import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Button } from '../../../components/button/button'
import { CTA as CTABase } from '../../../components/cta/cta'
import { isNotNull } from '../../../utils/nonNull'
import { FullScreenCtaFragment } from '@gql'

export type FullScreenCtaProps = {
  data: FullScreenCtaFragment[]
}

const StyledCTAButton = styled(Button)`
  border-radius: ${props => props.theme.typography.pxToRem(4)};
  padding: ${props => props.theme.typography.pxToRem(15)} ${props => props.theme.typography.pxToRem(30)} ${props => props.theme.typography.pxToRem(15)} ${props => props.theme.typography.pxToRem(30)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding: ${props => props.theme.typography.pxToRem(23)} ${props => props.theme.typography.pxToRem(44)} ${props => props.theme.typography.pxToRem(24)} ${props => props.theme.typography.pxToRem(44)};
  }
`

export const FullScreenCta: React.FC<PropsWithChildren<FullScreenCtaProps>> = ({ data }) => {
  if (!data[0] || data[0].__typename !== 'fullScreenCta_BlockType') {
    return null
  }

  const { background, text, ctaLink } = data[0]

  return background?.[0]?.url ? (
    <CTABase imageURL={background[0].url}>
      <CTABase content>
        <CTABase heading>
          {text}
        </CTABase>
        <CTABase buttons>
          { ctaLink && ctaLink.__typename === 'linkField_Link' && isNotNull(ctaLink.url) && isNotNull(ctaLink.customText) && (
            <StyledCTAButton cta href={ctaLink.url || '#'}>{ctaLink.customText}</StyledCTAButton>
          )}
        </CTABase>
      </CTABase>
    </CTABase>
  ) : null
}